import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=39b12ebc&scoped=true&"
import script from "./OptionSelect.vue?vue&type=script&lang=js&"
export * from "./OptionSelect.vue?vue&type=script&lang=js&"
import style0 from "./OptionSelect.vue?vue&type=style&index=0&id=39b12ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b12ebc",
  null
  
)

export default component.exports